import { render, staticRenderFns } from "./EmptyAccountPalce.vue?vue&type=template&id=46775dd8&scoped=true&"
import script from "./EmptyAccountPalce.vue?vue&type=script&lang=ts&"
export * from "./EmptyAccountPalce.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyAccountPalce.vue?vue&type=style&index=0&id=46775dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46775dd8",
  null
  
)

export default component.exports